// extracted by extract-css-chunks-webpack-plugin
module.exports = {"productHeroContainer":"productHeroContainer_X38O1"};